import { render, staticRenderFns } from "./NextPreviousButtons.vue?vue&type=template&id=6bf5bfb0&scoped=true&"
import script from "./NextPreviousButtons.vue?vue&type=script&lang=js&"
export * from "./NextPreviousButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf5bfb0",
  null
  
)

export default component.exports